import {
  ConeGeometry,
  CylinderGeometry,
  Group,
  Mesh,
  MeshStandardMaterial,
  SphereGeometry
} from 'three';

/** Caitlyn mesh — rifle silhouette. */
export function createCaitlynMesh(team = 'blue') {
  const group = new Group();
  const trim = team === 'blue' ? 0x93c5fd : 0xfca5a5;
  const bodyMat = new MeshStandardMaterial({ color: 0x1e3a5f, roughness: 0.5 });
  const trimMat = new MeshStandardMaterial({ color: trim, roughness: 0.35 });
  const rifleMat = new MeshStandardMaterial({ color: 0xcbd5e1, metalness: 0.55, roughness: 0.35 });
  const body = new Mesh(new ConeGeometry(0.5, 2.15, 10), bodyMat);
  body.position.y = 1.25;
  group.add(body);
  const head = new Mesh(new SphereGeometry(0.36, 12, 12), trimMat);
  head.position.y = 2.55;
  group.add(head);
  const rifle = new Mesh(new CylinderGeometry(0.05, 0.07, 2.4, 8), rifleMat);
  rifle.rotation.z = Math.PI / 2;
  rifle.position.set(0.85, 1.7, 0.1);
  group.add(rifle);
  return group;
}
